import { ReactElement } from "react";

export const Stub = ():ReactElement => {
  return (
    <div className={'stub__wrap'}>
      <div className={'game-stub'}>
          <div className={'stub__column stub__column_left'}>
            <div className={'stub__zavod'}></div>
          </div>
          <div className={'stub__column stub__column_right'}>
            <span className={'font_beige'}>Грандиозная ночная распродажа</span>
            <h1 className={'headline stub__headline font_beige'}>Готовь смартфон<br/> и лови мегаскидки<br/> до 40% прямо в эфире</h1>
            <span className={'headline font_green'}>24 ноября в 23:00<br/> только в эфире<br/> ПЯТНИЦА!</span>
          </div>
      </div>
      <div className={'stub__gears'}></div>
    </div>
  )
}